import { getFromLocalStorage, setToLocalStorage } from '../../common/dom-helpers'
import { LocalStorageKeys } from '../../environments'

export const internalDomainList = [
  '@logmein.com', // former logmein
  '@goto.com', // current goto
  '@jive.com', // former jive
  '@jedix.com', // domain used for internal mail
  '@guthrie.com', // domain used for training
]

export enum Product {
  WEB = 'gtc-web',
}
export const isInternal = (email?: string) =>
  email ? !!internalDomainList.find(domain => email.toLowerCase().endsWith(domain)) : false

export const getLDAnonymousUUIDKey = () => {
  let uuid: string | null
  uuid = getFromLocalStorage(LocalStorageKeys.launch_darkly_uuid)
  if (!uuid) {
    uuid = globalThis.crypto.randomUUID()
    setToLocalStorage(LocalStorageKeys.launch_darkly_uuid, uuid)
  }
  return uuid
}
